import React, { useState } from 'react';
import { useScrollEnd } from '@umu/umu-react-hooks';
import { bodyEle, scrollTo } from '@umu/umu-dom';

import './backTopBtn.scss';

interface IProps {
    children: JSX.Element;
    distance?: number; // 最小滚动距离
    element?: HTMLElement | null;
}

/**
 * 长列表，滚动到底部显示 “返回” 顶部按钮
 */
export function BackTopBtn(props: IProps) {
    const [show, setShow] = useState(false);
    const { children, element, distance = 800 } = props;
    const ele = element || bodyEle;

    useScrollEnd(
        () => {
            if (ele.scrollTop > distance) {
                setShow(true);
            } else {
                setShow(false);
            }
        },
        [],
        element || undefined,
    );

    const onClick = () => {
        scrollTo(0, ele, 'smooth');
        setShow(false);
    };

    return (
        <div className={`back-top-btn ${!show ? 'hide' : ''}`} onClick={onClick}>
            {children}
        </div>
    );
}
